import {
  initGlitchTipBrowser,
  triggerGlitchTipDebugIfRequested,
  setupGlitchTipAxiosInterceptors,
} from './utils/sentry.js'
import { setupGlobalOfflineToast } from './offlineToast.js'

initGlitchTipBrowser()
triggerGlitchTipDebugIfRequested()

setupGlobalOfflineToast()

// PAGES
const pageHome = document.querySelector('.page_inicial')
const pageQuemSomos = document.querySelector('.body_quem_somos')
const pageItem = document.querySelector('.page_item')
const pageItems = document.querySelector('.page_items')
const pageMinhaConta = document.querySelector('.page_minha_conta')
const pageHomologado = document.querySelector('.page_homologado')
const pageCadastroFisico = document.querySelector('.page_cadastro_fisico')
const pageCadastroJuridico = document.querySelector('.page_cadastro_juridico')
const pageLoteGrupo = document.querySelector('.page_lote_grupo')
// SCRIPT SENHA LOGIN
import mostrarSenha from './mostrarSenha.js'
import showFormErrors from './showFormErrors.js'

mostrarSenha()
showFormErrors()

// SECTIONS

import AlfaLeiloesSwipersHome from './swipers.js'
import AlfaLeiloesQuemSomos from './alfa-leiloes/alfaLeiloesQuemSomos.js'
import AlfaLeiloesHome from './alfa-leiloes/alfaLeiloesHome.js'
import alfaLeiloesSwiperCards from './alfa-leiloes/alfaLeiloesSwiperCards.js'
import Filter from './api/filter.js'
import ContatoJudicial from './alfa-leiloes/contatoJudicial.js'
import ContatoExtraJudicial from './alfa-leiloes/contatoExtraJudicial.js'
import ContatoNewsLetter from './alfa-leiloes/contatoNewsLetter.js'
import LembrarSenha from './alfa-leiloes/lembrarSenha.js'
import menu from './alfa-leiloes/menu.js'
import homologado from './alfa-leiloes/homologado.js'
import cadastroModal from './alfa-leiloes/alfaLeiloesCadastro.js'

ContatoJudicial()
ContatoExtraJudicial()
ContatoNewsLetter()
menu()
cadastroModal()

function getURLParameter() {
  const urlParams = new URLSearchParams(window.location.search)

  return {
    titulo: urlParams.get('titulo'),
    mensagem: urlParams.get('toastify'),
  }
}
const toastifyValue = getURLParameter()
console.log(toastifyValue)
if (toastifyValue.titulo || toastifyValue.mensagem) {
  Swal.fire({
    position: 'top',
    title: toastifyValue.titulo,
    text: toastifyValue.mensagem,
    showCloseButton: true,
    showConfirmButton: false,
    color: '#111',
  })

  // GLOBAL.showToastify(toastifyValue)
}

// ★ Pages Scopo


if (pageHome) {
  AlfaLeiloesSwipersHome()
  alfaLeiloesSwiperCards()
  AlfaLeiloesHome()
  Filter()
 
} else if (pageQuemSomos) {
  AlfaLeiloesQuemSomos()
} else if (pageItem) {
  // AlfaLeiloesItem();
  // modalItem();
  // hora();
  // data();
  // AlfaLeiloesHome();
  // Filter();
  // teste();
} else if (pageItems) {
  AlfaLeiloesHome()
  Filter()
  // loteGrupo()
  // AlfaLeiloesHome();
  // addFilterURLAndReload();
  // Filter();
  // alfaLeiloesSwiperCards();
} else if (pageMinhaConta) {
  // MinhaConta();
} else if (pageHomologado) {
  homologado()
} else if (pageCadastroFisico) {
  // inputSelect();
  // brasilAPI();
} else if (pageCadastroJuridico) {
  // brasilAPI();
}
// else if (pageLoteGrupo) {
//   Filter()
//   loteGrupo()
// }
 
LembrarSenha()

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('dcl')
  document.body.classList.add('DomContentLoaded')

  setupGlitchTipAxiosInterceptors()

  function FMoney(value, opts) {
    if (!value) return
    const result = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      ...opts,
    }).format(value)

    return result
  }

  document.querySelectorAll('[js-money]')?.forEach((i) => {
    if (i.innerText == 'None') {
      return
    }
    const val = FMoney(i.innerText?.replace(',', '.').trim())
    i.innerText = val ? val : '-'
  })

  var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
  });


  function onSubmitRecaptcha(e){
    console.log('oie')
  }
  

  window.onSubmitRecaptcha =  onSubmitRecaptcha
})
